import {avatarHueFor} from '#/lib/dashboardPalette'
import {useProfileQuery} from '#/state/queries/profile'
import {useSession} from '#/state/session'

export function useAuth() {
  const {currentAccount} = useSession()
  const {data: profile, isLoading} = useProfileQuery({
    did: currentAccount?.did,
  })

  // All hooks are called above this guard — the early return is intentional and rules-compliant.
  // Do not insert additional hook calls after this point.
  if (!currentAccount || !profile) {
    return {user: null, isLoading}
  }

  const accountType = (profile as unknown as Record<string, unknown>)
    .accountType
  const isTeacher = accountType === 'creator' || accountType === 'organisation'

  return {
    user: {
      id: currentAccount.did,
      role: isTeacher ? ('teacher' as const) : ('student' as const),
      displayName: profile.displayName ?? profile.handle ?? '',
      handle: `@${profile.handle ?? ''}`,
      avatarColor: avatarHueFor(currentAccount.did),
    },
    isLoading,
  }
}
